export const checkValuesHasNull = (values, listQuestion) => {
  return values?.data
    ?.slice(listQuestion.slice(0)[0]?.id - 1, listQuestion.slice(-1)[0]?.id)
    .includes(null);
};

export const GoToNextSection = (values, listQuestion, index) => {
  return (
    values.data.slice(
      listQuestion.slice(0)[0]?.id - 1,
      listQuestion.slice(-1)[0]?.id
    ).length === listQuestion.slice(-1)[0]?.question_number &&
    index === listQuestion.slice(-1)[0]?.question_number - 1
  );
};
